import type { i18n as I18nInstance } from 'i18next';
import { ar } from './ar';
import { he } from './he';
import { en } from './en';
import type { SupportedLocale } from './direction';

export const ADMIN_I18N_RESOURCES = {
  ar,
  he,
  en,
} as const;

const syncedAdminResourceRefs = new WeakMap<
  I18nInstance,
  {
    readonly ar: typeof ar;
    readonly he: typeof he;
    readonly en: typeof en;
  }
>();

export function installAdminI18nResources(
  instance: I18nInstance,
  options: { readonly force?: boolean } = {},
): void {
  const refs = syncedAdminResourceRefs.get(instance);
  if (!options.force && refs?.ar === ar && refs.he === he && refs.en === en) return;

  (
    Object.entries(ADMIN_I18N_RESOURCES) as Array<
      [SupportedLocale, (typeof ADMIN_I18N_RESOURCES)[SupportedLocale]]
    >
  ).forEach(([locale, translation]) => {
    instance.addResourceBundle(locale, 'translation', translation, true, true);
  });

  syncedAdminResourceRefs.set(instance, { ar, he, en });
}
